import React, { useEffect, useState } from "react";
import { useSchemaDomain } from "../../hooks/useSchemaDomain";
import Loading from "../Loading/Loading";
import { StorageHelper } from "../../utils/storageHelper";

export const SchemaProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(
    () => !!StorageHelper.get("token")
  );
  const { schemaInfo, loading, error, refetch } = useSchemaDomain();
  useEffect(() => {
    const checkAuth = () => {
      const hasToken = !!StorageHelper.get("token");
      setIsAuthenticated(hasToken);
    };
    checkAuth();
    window.addEventListener("storage", checkAuth);
    return () => window.removeEventListener("storage", checkAuth);
  }, []);

  useEffect(() => {
    if (isAuthenticated && error) {
      const timer = setTimeout(() => {
        refetch();
      }, 1000);
      return () => clearTimeout(timer);
    }
  }, [error, refetch, isAuthenticated]);

  if (!isAuthenticated) {
    return children;
  }

  if (loading && !schemaInfo) {
    return <Loading open={true} />;
  }

  if (schemaInfo) {
    return children;
  }

  return (
    <Loading open={true} error="Unable to load application configuration" />
  );
};
